/* Electro Emporium motion layer (GSAP + ScrollTrigger).
   Every animation here communicates something: hierarchy (hero intro, staggers),
   feedback (magnetic buttons, hover depth), or progress (scroll bar, pinned story).
   Fully disabled under prefers-reduced-motion. */
(function () {
  'use strict';
  var root = document.documentElement;
  var done = function () { root.classList.remove('ee-pre'); };
  if (!window.gsap || !window.ScrollTrigger) { done(); return; }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { done(); return; }

  var gsap = window.gsap, ScrollTrigger = window.ScrollTrigger;
  gsap.registerPlugin(ScrollTrigger);
  gsap.defaults({ ease: 'power3.out' });
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- scroll progress bar ---------- */
  var bar = document.createElement('div');
  bar.className = 'ee-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);
  gsap.to(bar, { scaleX: 1, ease: 'none', scrollTrigger: { trigger: document.body, start: 'top top', end: 'bottom bottom', scrub: 0.3 } });

  /* ---------- hero intro ---------- */
  var hero = $('[data-ee-hero]');
  if (hero) {
    var cuts = $$('.ee-cut', hero);
    var baseRot = cuts.map(function (c) { return parseFloat(c.style.getPropertyValue('--r')) || 0; });
    var tl = gsap.timeline({ defaults: { ease: 'power4.out' }, onComplete: done });
    tl.to('.ee-line > span', { yPercent: 0, duration: 1.05, stagger: 0.12 }, 0.05)
      .to('.ee-hero__tag, .ee-hero__copy p, .ee-hero__cta', { autoAlpha: 1, y: 0, duration: 0.8, stagger: 0.09 }, 0.2)
      .fromTo(cuts, { autoAlpha: 0, y: 110, scale: 0.8, rotation: function (i) { return baseRot[i] + (i % 2 ? 16 : -16); } },
                    { autoAlpha: 1, y: 0, scale: 1, rotation: function (i) { return baseRot[i]; }, duration: 1.4, stagger: 0.15, ease: 'expo.out' }, 0.25)
      .fromTo('.ee-hero__badge', { autoAlpha: 0, scale: 0.6, rotation: -12 }, { autoAlpha: 1, scale: 1, rotation: -4, duration: 0.9, ease: 'back.out(2)' }, 1.0)
      .add(function () { countUp($('.ee-hero__badge [data-count]')); }, 1.1);
    setTimeout(done, 2800);
    setTimeout(function () { if (tl.progress() < 1) tl.progress(1); }, 5000);

    /* products drift on their own rhythm: reads as a live shelf */
    var drifts = cuts.map(function (c, i) {
      var img = $('.ee-cut__img', c);
      return gsap.to(img, { y: (i % 2 ? 10 : -10), rotation: (i % 2 ? -1.2 : 1.2), duration: 3.4 + i * 0.6, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: 1.6 + i * 0.2 });
    });
    /* only animate while the hero is on screen (saves paint work once scrolled away) */
    ScrollTrigger.create({ trigger: hero, start: 'top bottom', end: 'bottom top', onToggle: function (s) { drifts.forEach(function (d) { s.isActive ? d.resume() : d.pause(); }); } });

    /* pointer parallax: nearer products move more (desktop only) */
    if (fine) {
      var movers = cuts.map(function (c) {
        var d = parseFloat(c.getAttribute('data-depth')) || 10;
        return { qx: gsap.quickTo(c, 'x', { duration: 1, ease: 'power3.out' }), qy: gsap.quickTo(c, 'y', { duration: 1, ease: 'power3.out' }), d: d };
      });
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var nx = (e.clientX - r.left) / r.width - 0.5, ny = (e.clientY - r.top) / r.height - 0.5;
        movers.forEach(function (m) { m.qx(nx * m.d * -2.6); m.qy(ny * m.d * -2.2); });
      });
      hero.addEventListener('pointerleave', function () { movers.forEach(function (m) { m.qx(0); m.qy(0); }); });
    }

    /* panel background drifts slower than the page */
    gsap.to('.ee-hero__bg', { yPercent: 12, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
  } else if (!$('[data-ee-chero]') && !$('.m6pr')) { done(); }

  /* ---------- product page: gallery and buy box ease in ---------- */
  var pdp = $('.m6pr');
  if (pdp) {
    var pg = $('.l4pr-container', pdp), pb = $('.f8pr', pdp);
    var ptl = gsap.timeline({ defaults: { ease: 'power4.out' }, onComplete: done });
    if (pg) ptl.fromTo(pg, { autoAlpha: 0, x: -36 }, { autoAlpha: 1, x: 0, duration: 1.1, clearProps: 'transform' }, 0.05);
    if (pb) ptl.fromTo(pb, { autoAlpha: 0, y: 34 }, { autoAlpha: 1, y: 0, duration: 1, clearProps: 'transform' }, 0.18);
    setTimeout(done, 2400);
    setTimeout(function () { if (ptl.progress() < 1) ptl.progress(1); }, 5000);
  }

  /* ---------- collection / info page header ---------- */
  var chero = $('[data-ee-chero]');
  if (chero) {
    var ctl = gsap.timeline({ defaults: { ease: 'power3.out' }, onComplete: done });
    ctl.to('.ee-chero__copy > *', { autoAlpha: 1, y: 0, duration: 0.6, stagger: 0.06 }, 0.02);
    setTimeout(done, 1800);
    setTimeout(function () { if (ctl.progress() < 1) ctl.progress(1); }, 3200);
  }

  /* ---------- magnetic buttons ---------- */
  if (fine) {
    $$('[data-magnetic]').forEach(function (el) {
      var qx = gsap.quickTo(el, 'x', { duration: 0.5, ease: 'power3.out' });
      var qy = gsap.quickTo(el, 'y', { duration: 0.5, ease: 'power3.out' });
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        qx((e.clientX - (r.left + r.width / 2)) * 0.22);
        qy((e.clientY - (r.top + r.height / 2)) * 0.32);
      });
      el.addEventListener('pointerleave', function () { qx(0); qy(0); });
    });
  }

  /* ---------- count-up ---------- */
  function countUp(el) {
    if (!el || el.__done) return; el.__done = true;
    var target = parseFloat(el.getAttribute('data-count')) || 0, o = { v: 0 };
    gsap.to(o, { v: target, duration: 1.6, ease: 'power3.out', onUpdate: function () { el.textContent = Math.round(o.v); } });
  }
  $$('[data-count]').forEach(function (el) {
    if (el.closest('.ee-hero')) return;
    el.textContent = '0';
    ScrollTrigger.create({ trigger: el, start: 'top 88%', once: true, onEnter: function () { countUp(el); } });
  });

  /* ---------- staggered reveals ---------- */
  function stagger(selector, childSel, opts) {
    $$(selector).forEach(function (wrap) {
      wrap.removeAttribute('data-reveal'); wrap.style.opacity = 1; wrap.style.transform = 'none';
      var kids = childSel ? $$(childSel, wrap) : Array.prototype.slice.call(wrap.children);
      if (!kids.length) return;
      gsap.set(kids, { autoAlpha: 0, y: opts.y || 34 });
      ScrollTrigger.create({ trigger: wrap, start: opts.start || 'top 86%', once: true, onEnter: function () {
        gsap.to(kids, { autoAlpha: 1, y: 0, duration: 0.85, stagger: opts.stagger || 0.06, ease: 'power3.out', clearProps: 'transform' });
      } });
    });
  }
  stagger('.ee-stats', '.ee-stat', { stagger: 0.09, y: 24 });
  stagger('.ee-cats', null, { stagger: 0.045 });
  stagger('.ee-grid', null, { stagger: 0.07 });
  stagger('.ee-spot', null, { stagger: 0.08 });
  stagger('.ee-rail', null, { stagger: 0.07, y: 28 });
  stagger('.ee-cond-grid', null, { stagger: 0.12, y: 44 });
  stagger('.ee-tiles', null, { stagger: 0.12, y: 50 });
  stagger('#collection', null, { stagger: 0.05, y: 30, start: 'top 92%' });
  stagger('.ee-quotes', null, { stagger: 0.12, y: 40 });
  stagger('.ee-why__list', null, { stagger: 0.1, y: 28 });
  stagger('.ee-posts', null, { stagger: 0.1, y: 22 });
  stagger('.ee-faq', 'details', { stagger: 0.07, y: 18 });

  /* headings rise into place */
  $$('.ee-head h2, .ee-why__lead h2, .ee-two h2, .ee-news h2').forEach(function (h) {
    gsap.from(h, { y: 34, autoAlpha: 0, duration: 0.9, scrollTrigger: { trigger: h, start: 'top 90%', once: true } });
  });

  /* ---------- parallax inside condition cards and deal band ---------- */
  $$('.ee-cbox__media img, .ee-deal2__art img').forEach(function (img) {
    gsap.fromTo(img, { yPercent: -5 }, { yPercent: 5, ease: 'none', scrollTrigger: { trigger: img.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } });
  });

  /* ---------- product card depth on hover ---------- */
  if (fine) {
    $$('.ee-card__top').forEach(function (top) {
      var rx = gsap.quickTo(top, 'rotationX', { duration: 0.6, ease: 'power3.out' });
      var ry = gsap.quickTo(top, 'rotationY', { duration: 0.6, ease: 'power3.out' });
      gsap.set(top, { transformPerspective: 900, transformOrigin: 'center' });
      top.addEventListener('pointermove', function (e) {
        var r = top.getBoundingClientRect();
        ry(((e.clientX - r.left) / r.width - 0.5) * 7);
        rx(((e.clientY - r.top) / r.height - 0.5) * -7);
      });
      top.addEventListener('pointerleave', function () { rx(0); ry(0); });
    });
  }

  /* ---------- pinned horizontal story (desktop) ---------- */
  var life = $('[data-ee-life]');
  if (life) {
    ScrollTrigger.matchMedia({
      '(min-width: 1025px)': function () {
        var pin = $('.ee-life__pin', life), track = $('.ee-life__track', life), fill = $('.ee-life__bar i', life);
        var cards = $$('.ee-lcard:not(.ee-lcard--end)', life), num = $('.ee-life__count b', life), lastN = -1;
        var dist = function () { return Math.max(1, track.scrollWidth - track.parentElement.clientWidth + 32); };
        gsap.to(track, { x: function () { return -dist(); }, ease: 'none',
          scrollTrigger: { trigger: life, start: 'top top', end: function () { return '+=' + dist(); }, pin: pin, scrub: 0.5, invalidateOnRefresh: true,
            onUpdate: function (s) {
              if (fill) fill.style.transform = 'scaleX(' + s.progress + ')';
              if (num) { var n = Math.min(cards.length, Math.floor(s.progress * cards.length) + 1); if (n !== lastN) { lastN = n; num.textContent = ('0' + n).slice(-2); } }
            } } });
      }
    });
  }

  /* refresh once images settle so pins measure correctly */
  window.addEventListener('load', function () { ScrollTrigger.refresh(); });
})();

/* hero hotspot cards: flip sideways / below when they would be clipped by the hero panel */
(function () {
  function place(h) {
    var card = h.querySelector('.ee-hot__card'), panel = h.closest('.ee-hero__panel');
    if (!card || !panel) return;
    h.classList.remove('is-flip', 'is-below');
    var r = card.getBoundingClientRect(), p = panel.getBoundingClientRect();
    if (r.right > p.right - 12) h.classList.add('is-flip');
    if (r.top < p.top + 12) h.classList.add('is-below');
  }
  function bind() {
    document.querySelectorAll('.ee-hot').forEach(function (h) {
      ['pointerenter', 'focusin'].forEach(function (ev) { h.addEventListener(ev, function () { place(h); }); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
